<!-- @format -->

<template>
	<div>
		<div v-if="loading">Loading.....</div>
		<div>Getting Invoice Report please wait....</div>
	</div>
</template>

<script>
import { useQuery, useResult } from '@vue/apollo-composable'
import { onMounted, reactive } from '@vue/composition-api'
import Store from '@/store'
import useProcessReportStore from '@/_srcv2/pages/_reports/create-report/useProcessReportStore.js'
import GetInvoiceReportDataQuery from './GetInvoiceReportDataQuery.graphql'
import useCalculateToPayFunctions from '@/_srcv2/pages/_reports/get-data-and-report/invoice/useCalculateToPayFunctions.js'
import useOcrNumber from '@/_srcv2/pages/_reports/create-report/useOcrNumber.js'

const { calculateToPay } = useCalculateToPayFunctions()
const { getOcrNumber, getSlicedOcrNumber } = useOcrNumber()

export default {
	name: 'GetInvoiceReportData',
	setup() {
		const {
			reportDocumentOurCompany,
			reportDocumentNumber,
			showGetData,
			showPdf,
			keyProcessReport,
			qr_nme,
			qr_cid,
			qr_iref,
			qr_idt,
			qr_ddt,
			qr_pt,
			qr_due,
			qr_acc,
			slicedOcrNumber,
			sendDocumentBy,
			hasValidEmail,
		} = useProcessReportStore()

		// ? get invoice report info
		const options = reactive({
			fetchPolicy: 'no-cache',
		})
		const { result, refetch, loading } = useQuery(
			GetInvoiceReportDataQuery,
			() => ({
				our_company: reportDocumentOurCompany.value,
				invoice_number: reportDocumentNumber.value,
			}),
			options,
		)
		// ****************************************************************************************************
		const getReportData = (data) => {
			return new Promise((resolve, reject) => {
				if (data !== null || undefined) {
					const allReportDataForInvoice = useResult(
						result,
						null,
						(data) => data.document_transactions,
					)
					console.log('allReportDataForInvoice', allReportDataForInvoice)
					resolve(allReportDataForInvoice.value[0])
				} else {
					const reason = new Error('Data could not be fetched from database')
					reject(reason)
				}
			})
		}
		// todo ---------------------------------------------------------------------------------------
		const validateEmail = (email) => {
			// eslint-disable-next-line no-useless-escape
			const regex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/
			return regex.test(email)
		}
		const storeState = (data) => {
			const lines = data.document_transaction_goods_transactions_rel
			const results = calculateToPay(data, lines, 'invoice')
			const ocr = getOcrNumber(
				data.invoice_number,
				data.customer.customer_id,
				results.correctedTotal,
			)
			console.log('======== > ocr', ocr)
			const slicedOcr = getSlicedOcrNumber(ocr)
			console.log('======== > slicedOcr', slicedOcr)
			qr_nme.value = data.company.company_name
			qr_cid.value = data.customer.customer_id
			qr_iref.value = ocr
			qr_idt.value = data.invoice_date.replaceAll('-', '')
			qr_ddt.value = data.invoice_due_date.replaceAll('-', '')
			qr_due.value = results.correctedTotal
			qr_pt.value = 'BG'
			qr_acc.value = data.company.company_bank_giro
			slicedOcrNumber.value = slicedOcr
			sendDocumentBy.value = data.customer?.send_invoice_by
			hasValidEmail.value = validateEmail(data?.customer?.customer_email)
		}

		const storeReportData = (data) => {
			return new Promise((resolve, reject) => {
				if (data !== null || undefined) {
					storeState(data)
					Store.dispatch('setPdfReportData', data).then(() => {
						if (Store.getters.getPdfReportData !== undefined) {
							showGetData.value = false
							showPdf.value = true
							keyProcessReport.value += 1
							resolve(true)
						}
					})
				} else {
					const reason = new Error('Data can not be stored')
					reject(reason)
				}
			})
		}
		// ----------------------------------------------------------------------------
		const a = () => {
			getReportData(result).then((data) => {
				storeReportData(data)
			})
		}
		console.log('GetInvoiceReport created is fired')
		onMounted(() => {
			console.log('GetInvoiceReport onMounted is fired')
			refetch().then(() => a())
		})
		// todo ---------------------------------------------------------------
		return {
			loading,
		}
	},
}
</script>

<style scoped>
.margin-top-25 {
	margin-top: 25px;
}
</style>
